<div class="category">
  <div class="flex" [ngClass]="{ 'custom-list-item-height': useCustomListItemHeight }">
    @if (fieldDefinitions$ | bisectAsync | async; as bisectResult) {
      @if (bisectResult[0]; as firstHalfOfFieldDefinitions) {
        <mat-list
          [id]="'toolbox-left-' + toolboxId"
          cdkDropList
          [cdkDropListData]="firstHalfOfFieldDefinitions"
          [cdkDropListEnterPredicate]="preventDrop"
          cdkDropListSortingDisabled
          dense
        >
          @for (fieldDefinition of firstHalfOfFieldDefinitions; track fieldDefinition) {
            <mat-list-item cdkDrag [cdkDragData]="fieldDefinition" class="draggable-item">
              <div class="custom-placeholder" *cdkDragPlaceholder></div>
              @if (!isLogo) {
                <rotec-chip-v2 [darkBlue]="true" [whiteFont]="true">
                  <rc-template-toolbox-item [item]="fieldDefinition"></rc-template-toolbox-item>
                </rotec-chip-v2>
              } @else {
                <rc-template-toolbox-item [item]="fieldDefinition"></rc-template-toolbox-item>
              }
              <!-- This item is only activated while dragging! -->
              <!-- NOTE:
              If you see an error below, this is due to the fact that the bisect pipe above is generic and 'ng' cannot resolve the actual type.
              With Ivy, this should be fixed.
              -->
              @if (fieldDefinition.type !== ReportTemplateFieldType.Image) {
                <span *cdkDragPreview translate>{{ fieldDefinition.name }}</span>
                <span *cdkDragPlaceholder translate>{{ fieldDefinition.name }}</span>
              }
            </mat-list-item>
          }
        </mat-list>
      }
      @if (!isLogo) {
        <div>
          @if (bisectResult[1]; as secondHalfOfFieldDefinitions) {
            <mat-list
              [id]="'toolbox-right-' + toolboxId"
              cdkDropList
              [cdkDropListData]="secondHalfOfFieldDefinitions"
              [cdkDropListEnterPredicate]="preventDrop"
              dense
            >
              @for (fieldDefinition of secondHalfOfFieldDefinitions; track fieldDefinition) {
                <mat-list-item cdkDrag [cdkDragData]="fieldDefinition" class="draggable-item">
                  <rotec-chip-v2 [darkBlue]="true" [whiteFont]="true">
                    <rc-template-toolbox-item [item]="fieldDefinition"></rc-template-toolbox-item>
                  </rotec-chip-v2>
                  <!-- This item is only activated while dragging! -->
                  <!-- NOTE:
                  If you see an error below, this is due to the fact that the bisect pipe above is generic and 'ng' cannot resolve the actual type.
                  With Ivy, this should be fixed.
                  -->
                  @if (fieldDefinition.type !== ReportTemplateFieldType.Image) {
                    <span *cdkDragPreview translate>{{ fieldDefinition.name }}</span>
                    <span *cdkDragPlaceholder translate>{{ fieldDefinition.name }}</span>
                  }
                </mat-list-item>
              }
            </mat-list>
          }
        </div>
      }
    }
  </div>
</div>
